import { render } from "./References.vue?vue&type=template&id=3c7b0378&lang=pug"
import script from "./References.vue?vue&type=script&setup=true&lang=js"
export * from "./References.vue?vue&type=script&setup=true&lang=js"

import "./References.vue?vue&type=style&index=0&id=3c7b0378&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__